export default __webpack_public_path__ + "static/media/Grimblocks.da719674.otf";